import hateoas from 'viralstyle-ui/src/hateoas';
import storage from 'viralstyle-ui/src/storage';
import clone from 'lodash/clone';
import isEqual from 'lodash/isEqual';

import config from 'config';
import router from '@/router';

const SIZE = 48;

export const getMarketplaceCampaigns = async ({ rootState, state, getters, dispatch, commit }, page = 1) => {
  let apiParams = [],
    query = clone(rootState.route.query),
    from = (page - 1) * SIZE,
    response,
    category,
    routePayload;

  apiParams.push(`from=${from}`);
  apiParams.push(`size=${SIZE}`);
  apiParams.push(`sort=${state.selectedSort}`);

  if (state.selectedCategory) {
    apiParams.push(`filters[]=category:${state.selectedCategory.id}`);

    query.category = state.selectedCategory.id;
  } else {
    delete query.category;
  }

  if (state.selectedProductType && state.selectedProductType !== '0') {
    apiParams.push(`filters[]=product_category:${state.selectedProductType}`);

    query.product_type = state.selectedProductType;
  } else {
    delete query.product_type;
  }

  if (getters.selectedSortQuery) {
    query.sort = getters.selectedSortQuery;
  } else {
    delete query.sort;
  }

  if (state.search) {
    apiParams.push(`filters[]=term:${state.search}`);

    query.search = state.search;
  } else {
    delete query.search;
  }

  routePayload = { name: 'marketplace', params: { page: page.toString() }, query };

  if (!isEqual(query, rootState.route.query) || page !== rootState.route.params.page) {
    if (rootState.route.name === 'marketplace') {
      router.replace(routePayload);
    } else {
      router.push(routePayload)
    }
  }

  commit('updateState', { object: state, property: 'campaigns', value: [] });

  response = await dispatch('get', `${hateoas.url('marketplace_search_campaigns')}?${apiParams.join('&')}`);

  commit('updateState', { object: state, property: 'campaigns', value: response.data.hits });
  commit('updateState', { object: state, property: 'maxPages', value: Math.ceil(response.data.total_hits / SIZE) });
  commit('updateState', { object: state, property: 'searchApplied', value: !!state.search });

  storage.set('last-listing-url', { url: rootState.route.fullPath, time: new Date() });

  return response;
};

export const getMarketplaceFilters = async ({ state, dispatch, commit }) => {
  if (!state.categories || !state.productTypes) {
    let response = await dispatch('backgroundGet', hateoas.url('marketplace_list_filters'));

    commit('updateState', { object: state, property: 'categories', value: response.data.categories });
    commit('updateState', { object: state, property: 'productTypes', value: response.data.product_types });

    return response;
  }
};

export const hideCampaign = async ({ dispatch, commit }, campaign) => {
  try {
    let response = await dispatch('patch', {
      apiUrl: `${config.CLIENT_ADMIN_API_URL}admin/campaigns/${campaign.campaign_id}/lock-marketplace`,
      payload: { lock: true },
      nonPublicScope: true,
    });

    commit('addNotification', `${campaign.name} hidden successfully.`);

    return response;
  } catch (e) {
    commit('addNotification', `Error occurred while attempting to hide ${campaign.name}.`);

    throw e;
  }
};